import { render } from "./userServiceAgreementView.vue?vue&type=template&id=53acd2ac&scoped=true"
import script from "./userServiceAgreementView.vue?vue&type=script&lang=js"
export * from "./userServiceAgreementView.vue?vue&type=script&lang=js"

import "./userServiceAgreementView.vue?vue&type=style&index=0&id=53acd2ac&lang=less&scoped=true"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53acd2ac"]])

export default __exports__